export default {
      id: "rose-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#rose",
      toString: function () {
        return this.url;
      }
    }